import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { catchError, tap } from "rxjs/operators";
import { AppConfigService } from "../app-config.service";
import { ToastService } from "../shared/toast.service";
import { TokenService } from "./token.service";
const ROUTER_STATE = "_routerState";
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private _tokenService: TokenService,
    private _router: Router,
    private _toastService: ToastService,
    private _route: ActivatedRoute,
    private _appConfigService: AppConfigService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (request.url.startsWith("/config"))
      return next
        .handle(request)
        .pipe(
          catchError((err: HttpErrorResponse) =>
            this.handleHttpClientError(err)
          )
        );
    if (this._tokenService.isTokenExpired()) {
      this._router.navigateByUrl("/login");
      return;
    }

    if (!request.url.startsWith("https://"))
      request = request.clone({
        url: `${this._appConfigService.getConfig().apiEndpoint}${request.url}`,
        setHeaders: {
          Authorization: `Bearer ${this._tokenService.getToken()}`,
        },
      });

    return next.handle(request).pipe(
      tap((res: any) => this.handleSuccess(res)),
      catchError((err: HttpErrorResponse) => this.handleHttpClientError(err))
    );
  }

  handleSuccess(res: any) {
    // API only returns 200 ok's so not possible to handle data saved atm
    // var status = res.status;
    // if (status != undefined && status != 200) {
    //   this._toastService.showSuccesToast("Success", "Data saved");
    // }
    return res;
  }

  handleHttpClientError(error: HttpErrorResponse) {
    if (error.status == 401) this.loginRedirect();
    else
      error?.error instanceof Blob
        ? this.showValidationErrorToasters(error)
        : this.showErrorToaster(error);

    return throwError(error);
  }

  private showValidationErrorToasters(err: any) {
    const reader = new FileReader();
    reader.onloadend = (e) => {
      var validationErrors = JSON.parse(
        e.target.result as string
      ).validationErrors;
      validationErrors.forEach((element) => {
        this._toastService.showErrorToast(element.title, element.description);
      });
    };
    reader.readAsText(err.error);
  }
  private showErrorToaster(err: any) {
    if (err.error?.validationErrors?.length) {
      err.error.validationErrors.forEach((element) => {
        this._toastService.showErrorToast(element.title, element.description);
      });
    } else if (err.error?.detailedError?.message) {
      this._toastService.showErrorToast(
        "Error",
        err.error.detailedError.message
      );
    } else {
      var detail =
        err?.error?.message ||
        "We couldn't process your request. Please try again later!";

      this._toastService.showErrorToast("Error", detail);
    }
  }

  private loginRedirect() {
    let queryParams = {};
    if (!this._route.snapshot[ROUTER_STATE].root.queryParams.redirectTo)
      queryParams = {
        redirectTo: this._route.snapshot[ROUTER_STATE].url,
      };
    else queryParams = this._route.snapshot[ROUTER_STATE].root.queryParams;

    this._router.navigate(["/login"], {
      queryParams,
    });
  }
}
